import {ComplaintStatus, LadingStatus} from "@/enums/status";
import {LadingType} from "@/enums/type";
import moment from "moment";
import {LIMIT_PAGE_DEFAULT} from "@/shared/constant";

export class LadingParams {
    page? = 1;
    limit? = LIMIT_PAGE_DEFAULT;
    search?: string;
    type?: LadingType;
    status?: LadingStatus;
    statusString?: string;
    ladingCode?: string;
    fromDate = moment().startOf('month').valueOf();
    toDate = (new Date()).valueOf();
    fromProvince: undefined;
    toProvince: undefined;
    freightServiceRowGuid: undefined;
    customerRowGuid?: string;
    acceptanceEmployeeRowGuid?: string;
    acceptancePostOfficeRowGuid?: string;
    statusCustomer?: string;
}
